<main class="container-fluid">
    <section class="sec-main p-0 m-0">
        <div class="row">
            <div class="col-sm-6 p-5 d-flex">
                <div class="container p-3">
                            <div (click)="naviagteToHomePage()" class="back-button">
                                <button  class="btn btn-primary setflex">
                                    <mat-icon>keyboard_backspace</mat-icon>
                                 <span style="display: flex;">Back</span> 
                                </button>
                            </div>
                            <h2 class="settings">Settings</h2>
                            <div class="preferences">Edit and save your preferences.</div>
                            <div class="units">Units</div>
                            <mat-chip-set class="mat-mdc-chip-set" aria-label="Color selection">
                                @for (unit of units; track $index) {
                                    <mat-chip class="mat-chip"
                                            (click)="unitSelected(unit, $index)" [selected]="unit.selected">{{unit.name}}
                                            @if(unit.selected){
                                                <mat-icon matChipRemove><span class="material-symbols-outlined">check</span></mat-icon>
                                            }
                                    </mat-chip>
                                }
                            </mat-chip-set>
                            <div class="row">
                                <button class="save-button btn btn-primary" 
                                       (click)="saveMeasurementsUnit()">
                                      Save changes
                                </button>
                            </div>
                        </div>
                    </div>
            <div class="col-sm-6 settings-pic"></div>
        </div>
    </section>
</main>
